import { render, staticRenderFns } from "./NewIdentificationNotify.vue?vue&type=template&id=5b462846"
import script from "./NewIdentificationNotify.vue?vue&type=script&lang=js"
export * from "./NewIdentificationNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports